document.addEventListener('click', (event) => {
  const btn = event.target.closest('.wb-menu-expand-btn');
  if (!btn) return;

  event.preventDefault();
  event.stopPropagation();

  const list = btn.closest('.wb-dropdown');
  if (!list) return;

  list.classList.add('wb-expanded');
  btn.closest('.wb-dropdown__expand-wrap')?.remove();
});

const hideOpenMenus = () => {
  if (document.querySelector('.wb-nav:hover, .wb-dropdown:hover, .wb-flyout:hover, .wb-flyout-open')) return;

  document.querySelectorAll('.wb-nav__item--parent').forEach((item) => {
    item.classList.add('wb-nav--scroll-hide');
  });
};

window.addEventListener('scroll', hideOpenMenus, { passive: true });

document.addEventListener('mouseover', (event) => {
  const parent = event.target.closest?.('.wb-nav__item--parent');
  if (parent) parent.classList.remove('wb-nav--scroll-hide');

  const flyItem = event.target.closest?.('.wb-has-flyout');
  document.querySelectorAll('.wb-has-flyout.wb-flyout-open').forEach((item) => {
    if (item !== flyItem) item.classList.remove('wb-flyout-open');
  });
  if (flyItem) flyItem.classList.add('wb-flyout-open');
});

document.addEventListener('mouseout', (event) => {
  const flyItem = event.target.closest?.('.wb-has-flyout');
  if (!flyItem) return;
  const next = event.relatedTarget;
  if (next instanceof Node && flyItem.contains(next)) return;
  window.setTimeout(() => {
    if (!flyItem.matches(':hover')) flyItem.classList.remove('wb-flyout-open');
  }, 180);
});
